import { QueryClient } from "@tanstack/react-query";

const MINUTE = 60 * 1000;

/** How long each kind of data is treated as fresh before a background refetch */
export const staleTimes = {
  default: 30 * 1000,
  reference: 60 * MINUTE, // Tags and locations rarely change
  sites: 10 * MINUTE,
  users: 5 * MINUTE,
  search: 5 * MINUTE,
  insight: 10 * MINUTE, // Only changes when the audience is saved, which updates the cache
};

export const createQueryClient = () => new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: staleTimes.default,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
